// tempexp_18086-start
import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import {
    goToReferralSubscriptions,
    REFERRAL_ANALYTIC_NAME,
    REFERRAL_PROMO_ASIDE_PROMO_ID,
    REFERRAL_PROMO_SPACE_PROMO_ID,
    REFERRAL_PROMO_SPACE_VISITS,
    referralProgramPromoSettings,
    referralProgramSpacePromoEnabled,
} from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { store as reduxStore } from 'reactApp/store';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

export function* initReferralProgramSpacePromo() {
    const storage = yield* select(getCurrentStorage);
    const { isHome } = getStorage(storage);
    const isMobile = yield* select(EnvironmentSelectors.isMobile);

    const asidePromoWasShown = storeHelper.getValue(REFERRAL_PROMO_ASIDE_PROMO_ID);

    /*
    Мы отсчитываем количество заходов после показа бокового промо,
    поэтому если его не показывали просто выходим.
    В самом asidePromo предусмотрен также механизм очистки счетчика REFERRAL_PROMO_SPACE_VISITS,
    для возобновления механизма показа Space промо, после следующего показа Aside
    */
    if (!asidePromoWasShown) {
        return;
    }

    // число показов Space промо
    const visitsCount = storeHelper.getValue(REFERRAL_PROMO_SPACE_VISITS) || 0;

    // Если мы показали больше требуемого числа раз, то выходим
    if (visitsCount > referralProgramPromoSettings.visitsAfterAside) {
        return;
    }

    // Если мы показали меньше требуемого числа раз, то увеличиваем счетчик и выходим.
    // Инкремент счетчика, так же будет происходить при показе тултипа, чтобы не было зацикливания показа.
    if (visitsCount < referralProgramPromoSettings.visitsAfterAside) {
        storeHelper.setValue(REFERRAL_PROMO_SPACE_VISITS, visitsCount + 1);
        return;
    }

    // показываем на /home и просмотрщике
    // скрываем если фича выключена (исключаем платников, корпов, бизов и соцников)
    // скрываем на автотестых и таче
    // исключаем если период еще не прошел для показа
    if (!isHome || !referralProgramSpacePromoEnabled || isMobile || IS_AUTO_TEST_HIDE) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.referralProgramSpacePromo,
            promoId: REFERRAL_PROMO_SPACE_PROMO_ID,
            onClick() {
                emitAnalyticEvent(AnalyticEventNames.REFERRAL_TOOLTIP_CLICK);
                sendPaymentGa({
                    action: 'click',
                    eventCategory: ECategoryGa.tooltip,
                    name: REFERRAL_ANALYTIC_NAME,
                });
                goToReferralSubscriptions();
                reduxStore.dispatch(removePromo(EPromoType.referralProgramSpacePromo));
            },
            onShow: () => {
                emitAnalyticEvent(AnalyticEventNames.REFERRAL_TOOLTIP_SHOW);
                sendPaymentGa({
                    action: 'show',
                    eventCategory: ECategoryGa.tooltip,
                    name: REFERRAL_ANALYTIC_NAME,
                });
                storeHelper.setValue(REFERRAL_PROMO_SPACE_VISITS, visitsCount + 1);
                storeHelper.markAsShown(REFERRAL_PROMO_SPACE_PROMO_ID);
                reduxStore.dispatch(promoShown(EPromoType.referralProgramSpacePromo));
            },
            onClose: () => {
                emitAnalyticEvent(AnalyticEventNames.REFERRAL_TOOLTIP_CLOSE);
                sendPaymentGa({
                    action: 'close',
                    eventCategory: ECategoryGa.tooltip,
                    name: REFERRAL_ANALYTIC_NAME,
                });
                reduxStore.dispatch(removePromo(EPromoType.referralProgramSpacePromo));
            },
        })
    );
}
// tempexp_18086-end
